import { HomepageCardBackgroundGradient } from '../../../Components/CUIHomepageCard/utils/backgroundGradients'; // FIXME: Change when https://github.com/chakra-ui/chakra-ui/issues/7648 is picked up

const baseStyle = {
  // select the indicator part
  indicator: {
    '&[data-status=active]': {
      borderColor: 'CARNABY.regular !important'
    },
    '&[data-status=complete]': {
      backgroundImage: `linear-gradient(${HomepageCardBackgroundGradient.kyotoCarnaby})`
    }
  },
  separator: {
    '&[data-status=complete]': {
      backgroundImage: `linear-gradient(${HomepageCardBackgroundGradient.kyotoCarnaby})`
    }
  }
};
export const stepperTheme = {
  baseStyle
};